import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { IAppointment, IAppointmentPage } from "./appointment.interface";
import IFilterAppointment from "./filterAppointment.interface";

class AppointmentService {
  // create
  createAppointment(payload: IAppointment | Record<string, unknown>, query?: { lang: string }) {
    return httpService.post(`${apiService.doctor.appointment.create}`, payload, {
      params: query,
    });
  }

  // get my appointments
  getMyAppointments(params?: IFilterAppointment) {
    return httpService.get<IAppointmentPage>(`${apiService.doctor.appointment.getMyAppointment}`, {
      params: params,
    });
  }

  // get by id
  getById(id: string | number) {
    return httpService.get<IAppointment>(`${apiService.doctor.appointment.getById}/${id}`);
  }

  getByKey(key: string) {
    return httpService.get<IAppointment>(`${apiService.doctor.appointment.getByKey}`, { params: { key } });
  }

  // cancel
  setCancelled(id?: string | number, cancel_reason?: string) {
    return httpService.put(`${apiService.doctor.appointment.setCancelled}/${id}`, undefined, { params: { cancel_reason } });
  }
  createFromPackage(body: any) {
    return httpService.post(`${apiService.doctor.appointment.createFromPackage}`, body);
  }

  /**
   * Attachments are uploaded after the appointment exists, so a failure here never costs the
   * booking - the caller is expected to swallow it. Every file goes under the same `files` field.
   */
  uploadAttachments(appt_key: string, files: File[]) {
    const formData = new FormData();

    files.forEach((file) => formData.append("files", file));

    return httpService.post(`${apiService.doctor.appointment.uploadAttachments}`, formData, { params: { appt_key } });
  }

  // `appt_key` scopes the file to its appointment; the apps send both.
  deleteAttachment(name: string, apptKey?: string) {
    return httpService.delete(`${apiService.doctor.appointment.deleteAttachment}`, { params: { appt_key: apptKey, name } });
  }

  /** Refuses a booking that clashes with the doctor's schedule or one the patient already holds. */
  checkExisted(body: unknown) {
    return httpService.post(apiService.doctor.appointment.checkExisted, body);
  }

  calculateFee(body: any, lang: string) {
    return httpService.post(apiService.doctor.appointment.calculateFee, body, {
      params: {
        lang: lang,
      },
    });
  }
}

export default new AppointmentService();
